/*
 * @providesModule MaintenancePopupStyles
 */

import {StyleSheet} from 'react-native';
import * as CommonStyles from 'CommonStyles';
import SkillzStyle from 'SkillzStyle';

const styles = StyleSheet.create({
  overlay: {
    ...CommonStyles.absoluteFill,
    ...CommonStyles.itemsCenter,
    ...CommonStyles.justifyCenter,
    backgroundColor: 'rgba(0, 0, 0, 0.9)',
  },
  logoContainer: {
    ...CommonStyles.itemsCenter,
    ...CommonStyles.positionAbsolute,
    ...CommonStyles.absoluteTop,
    ...CommonStyles.pt28_5,
  },
  container: {
    ...CommonStyles.itemsCenter,
    ...CommonStyles.px6,
  },
  logoIcon: {
    width: 55,
    height: 50,
  },
  logoWordmark: {
    width: 130,
    height: 35,
    ...CommonStyles.mt1_5,
  },
  maintenanceImage: {
    width: 200,
    height: 200,
    ...CommonStyles.mt20,
  },
  heading: {
    ...CommonStyles.text26,
    ...CommonStyles.textWhite,
    ...SkillzStyle.fullStyles.fontBold,
    ...CommonStyles.textCenter,
    ...CommonStyles.mt20,
  },
  subheading: {
    ...CommonStyles.text20,
    ...CommonStyles.textWhite,
    ...CommonStyles.opacity60,
    ...CommonStyles.textCenter,
    ...CommonStyles.mt2,
  },
});

export default styles;
